/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : PhoneNumberTextField.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 06-07-2024
 * @description Reusable phone number text field with phone code select option
 */
import {
  Box,
} from "@mui/material";
import CustomSelectV3 from "../customComponentsV2/common/select/CustomSelectV3";
import CustomFormTextFieldV3 from "../customComponentsV2/common/textField/CustomFormTextFieldV3";

function PhoneNumberTextField({
  size = "small",
  variant = "outlined",
  phoneCodeLabel = "Country Code",
  phoneNumberLabel = "Phone Number",
  phoneCodeOptions = [],
  selectedPhoneCode,
  setSelectedPhoneCode,
  phoneNumber,
  setPhoneNumber,
  phoneNumberError,
  setPhoneNumberError,
  phoneCodeStyle = {},
  phoneNumberStyle = {},
  required = false,
}) {
  /** ------------------------------
   * Phone Code Change
   * ------------------------------ */
  const handlePhoneCodeChange = (e) => {
    setSelectedPhoneCode(e.target.value);
    setPhoneNumberError("");
  };

  /** ------------------------------
   * Phone Number Change
   * ------------------------------ */
  const handlePhoneNumberChange = (val) => {
    const numericValue = String(val).replace(/\D/g, "");

    if (!selectedPhoneCode) {
      setPhoneNumberError("Select country code first");
      return;
    }

    if (numericValue.length > 10) return;

    setPhoneNumberError("");
    setPhoneNumber(numericValue);
  };

  return (
    <Box display="flex" gap={1}>
      {/* Country Code Select */}
      <Box>
        <CustomSelectV3
          size={size}
          variant={variant}
          label={phoneCodeLabel}
          required={required}
          optionsList={phoneCodeOptions}
          selectedValue={selectedPhoneCode}
          handleOnChange={handlePhoneCodeChange}
          sltFldStyle={phoneCodeStyle}
          placeholder="Select country"
        />
      </Box>

      {/* Phone Number Field */}
      <CustomFormTextFieldV3
        size={size}
        variant={variant}
        label={phoneNumberLabel}
        type=""
        fldType=""
        value={phoneNumber}
        setValue={handlePhoneNumberChange}
        valueError={phoneNumberError}
        setValueError={setPhoneNumberError}
        required={required}
        txtFldStyle={phoneNumberStyle}
        inputProps={{
          maxLength: 10,
        }}
      />

    </Box>
  );
}

export default PhoneNumberTextField;
